import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { GlobalEmailTemplate } from '@models/global-email-templates';
import { Repo } from '../../repo.service';

@Injectable({
	providedIn: 'root',
})
export class GlobalEmailTemplateVersionsRepo extends Repo<
	GlobalEmailTemplate,
	{ templateId: string }
> {
	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	GetCollectionPath(pathParams: { templateId: string }): string {
		return CollectionPaths.global_email_template_versions(
			pathParams.templateId,
		);
	}
}
